import { Container, Service } from 'typedi';
import { LoggerProvider } from '../../logger';
import { ClickStreamTrackingProvider } from '../../tracking';
import {
    EventFormatterBuilder,
    EventFormatterBuilderFactory,
    Level,
} from '@unified-client/event-formatter';
import { IMrGreenMigrationEventSender } from '../models/interfaces/IMrGreenMigrationEventSender';
import { Utils } from '../../utils';
import { IMrGreenMigrationClickStreamEventData } from '../models/interfaces/IMrGreenMigrationClickStreamEventData';
import {
    MrGreenMigrationElasticEvents,
    MRGreenMigrationEventAction,
    MRGreenMigrationEventCategory,
    MRGreenMigrationSourceEvent,
} from '../enums/consts';
import { EventType } from '@unified-client/event-formatter/dist/models';
import { ILogger } from '@sparkware/uc-sdk-core';

@Service()
export class MrGreenMigrationLogging {
    private _correlationID: string;
    private _businessCorrelationId: string;
    private _token: string;
    private _source: string;
    private _migrationCompletionIndication: boolean;
    private readonly _system: string;
    private readonly _orientation: string;
    private readonly _logger: ILogger;
    private readonly _clickStreamTrackingProvider: ClickStreamTrackingProvider;
    private readonly _eventFormatterBuilder: EventFormatterBuilder;
    private readonly _utils: Utils;

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('MrGreenMigration');
        const efBuilderFactory = Container.get(EventFormatterBuilderFactory);
        this._eventFormatterBuilder = efBuilderFactory.createEventFormatterBuilder(
            MrGreenMigrationElasticEvents.MIGRATION_EVENT,
        );
        this._clickStreamTrackingProvider = Container.get(ClickStreamTrackingProvider);
        this._utils = Container.get(Utils);

        this._system = this._utils.findIfIsNative() ? '888 app' : '888 web';
        this._orientation = 'Sport';
    }

    public GetElasticEventSender(
        correlationId: string,
        businessCorrelationId: string,
        token: string,
        source: string,
        migrationCompletionIndication: boolean,
    ): IMrGreenMigrationEventSender {
        this._correlationID = correlationId;
        this._businessCorrelationId = businessCorrelationId;
        this._token = token;
        this._source = source;
        this._migrationCompletionIndication = migrationCompletionIndication;

        return {
            sendBIOnVisitEvent: (fName: string): void => {
                const formatter = this._eventFormatterBuilder.createFormatter(fName);
                const eventData: IMrGreenMigrationClickStreamEventData = {
                    event: MrGreenMigrationElasticEvents.MIGRATION_EVENT,
                    EventActionData: {
                        TokenIncluded: !!this._token,
                        System: this._system,
                        Source: this._source
                            ? MRGreenMigrationSourceEvent.MRG_REDIRECTION
                            : MRGreenMigrationSourceEvent.VISITOR,
                        Orientation: this._orientation,
                        MigrationCompletionIndication: this._migrationCompletionIndication,
                    },
                    EventAction: MRGreenMigrationEventAction.ENTER,
                    EventCategory: MRGreenMigrationEventCategory.VISITOR,
                };

                this.sendElasticEvent(formatter, eventData);
            },
        };
    }

    public sendElasticEvent(formatter: any, eventData: any, level: Level = undefined): void {
        const correlationID = this._correlationID;
        const businessCorrelationID = this._businessCorrelationId;

        const event = formatter.formatBusinessEvent(
            {
                eventName: eventData.event,
                eventType: [EventType.Log, EventType.Analytics],
            },
            {
                correlationID,
                businessCorrelationID,
            },
            eventData,
        );
        this._clickStreamTrackingProvider.sendEventV2(event);
    }
}
